import { render } from "./NewTenant.vue?vue&type=template&id=c2b6a5a2"
import script from "./NewTenant.vue?vue&type=script&lang=js"
export * from "./NewTenant.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__